// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ee671459","455":"a2df7ebb","977":"7de16a02"}[chunkId] + ".chunk.js";
};